import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { navItems } from "../../frontends/home/data/data";

const Footer = () => {
  return (
    <Box
      sx={{
        borderTop: "1px solid rgba(100, 255, 218, 0.1)",
        py: 4,
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        justifyContent: "space-between",
        px: { xs: 3, md: 10 },
        gap: 2,
      }}
    >
      <Typography
        sx={{
          color: "#a8b2d8",
          fontFamily: "Montserrat, sans-serif",
          fontSize: "0.85rem",
        }}
      >
        Copyright © Bradley Rushforth 2025
      </Typography>

      <Box sx={{ display: "flex", gap: 1 }}>
        {navItems.map((item) => (
          <Button
            key={item.label}
            component={Link}
            to={item.path}
            sx={{
              color: "#a8b2d8",
              fontFamily: "Montserrat, sans-serif",
              fontSize: "0.8rem",
              letterSpacing: "1px",
              textTransform: "uppercase",
              "&:hover": {
                color: "#64ffda",
                backgroundColor: "transparent",
              },
            }}
          >
            {item.label}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export default Footer;
